/* this file is transformed by vux-loader */
/* eslint-disable */
import "core-js/modules/es6.regexp.replace";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es7.promise.finally";
import axios from 'axios';
import store from '@/store';
import route from '@/router';
import Catcher from './errCatcher';
import env from './env';
var service = axios.create({
  timeout: 150000,
  headers: {
    'content-type': 'application/json'
  }
});
window.cancelTokenList = [];
var defaultRequestData = {
  version: env.appVersion,
  releaseVersion: env.releaseVersion,
  from: 'h5',
  systemCode: 'A3',
  platform: env.platformCode
};
service.interceptors.request.use(function (config) {
  config.data = config.data || {};
  Object.assign(config.data, defaultRequestData);

  if (config.data.action) {
    config.url = "".concat(config.url, "?").concat(config.data.action);
  }

  var _config$loginName = config.loginName,
      loginName = _config$loginName === void 0 ? 'login' : _config$loginName;

  if (!config.ignoreLogin) {
    var loginResult = store.state.user.loginResult;

    if (!loginResult || !loginResult.ticket || !loginResult.token) {
      route.replace({
        name: loginName,
        query: route.currentRoute.query
      });
      throw new Error('请先登录');
    }

    config.data.token = loginResult.token;
    config.data.ticket = loginResult.ticket;
  } else if (config.token) {
    config.headers.token = config.token;
  } // 全局CancelToken


  var source = axios.CancelToken.source();
  window.cancelTokenList.push(source);
  config.cancelToken = source.token;
  return config;
}, function (error) {
  Promise.reject(error);
});
service.interceptors.response.use(function (response) {
  var _response$config$logi = response.config.loginName,
      loginName = _response$config$logi === void 0 ? 'login' : _response$config$logi; // 处理全局CancelToken List

  window.cancelTokenList = window.cancelTokenList.filter(function (x) {
    return x.token !== response.config.cancelToken;
  }); // 各种返回状况处理

  var res = response && response.data;
  if (res.code !== 0) Catcher(response, false, loginName);
  return res;
}, function (error) {
  if (error instanceof Error) {
    throw error;
  }

  Catcher(error.response, true);
});
export default service;